// src/features/inventory/pages/SupplierDetailPage/SupplierHeader.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Chip } from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material';

import PageHeader from '../../../../components/common/PageHeader';

export default function SupplierHeader({ supplier, canUpdate, canDelete, onToggleActive, onEdit, onDelete, onBack }) {
  const { t } = useTranslation(['inventory', 'common']);

  return (
    <PageHeader
      onBack={onBack}
      title={supplier.name}
      badges={
        <Chip
          label={supplier.active ? t('common:status.active') : t('common:status.inactive')}
          color={supplier.active ? 'success' : 'primary'}
          size="small"
          variant="outlined"
          onClick={canUpdate ? onToggleActive : undefined}
          sx={{ ...(canUpdate && { cursor: 'pointer' }) }}
        />
      }
      subtitle={supplier.code}
      actions={<>
        {canDelete && (
          <Button variant="outlined" color="error" startIcon={<DeleteIcon />} onClick={onDelete}>
            {t('common:buttons.delete')}
          </Button>
        )}
        {canUpdate && (
          <Button variant="contained" startIcon={<EditIcon />} onClick={onEdit}>
            {t('common:buttons.edit')}
          </Button>
        )}
      </>}
    />
  );
}
